// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
import { z } from 'zod';
const createGuard = z.object({
    tenantId: z.string().max(21).optional(),
    id: z.string().min(1).max(21),
    name: z.string().min(1).max(128),
    description: z.string().max(256).nullable().optional(),
});
const guard = z.object({
    tenantId: z.string().max(21),
    id: z.string().min(1).max(21),
    name: z.string().min(1).max(128),
    description: z.string().max(256).nullable(),
});
export const OrganizationScopes = Object.freeze({
    table: 'organization_scopes',
    tableSingular: 'organization_scope',
    fields: {
        tenantId: 'tenant_id',
        id: 'id',
        name: 'name',
        description: 'description',
    },
    fieldKeys: [
        'tenantId',
        'id',
        'name',
        'description',
    ],
    createGuard,
    guard,
    updateGuard: guard.partial(),
});
